<template>
  <div class="how-study">
    <div class="ha-des">
      <p class="black">如何进行家庭自学？</p>
      <p>点击下方链接，查看家庭自学指导手册</p>
      <a href="https://mp.weixin.qq.com/s/iMtt8u7vBsf7VAcHK2eNHg">https://mp.weixin.qq.com/s/iMtt8u7vBsf7VAcHK2eNHg</a>
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-study {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
        word-break: break-all;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title='如何进行学习? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何进行学习')
    },
    components: {}
  }
</script>
